import type { HelpFile } from '../../types/help'
import { ErrorLogsTestIds } from '../../../testids/ErrorLogsTestIds'

export const errorLogsHelp: HelpFile = {
  docPage: '/docs/admin/error-log',
  texts: {
    [ErrorLogsTestIds.systemFailuresPage]:
      'System error log capturing backend exceptions and frontend errors. Free-text search matches the error message only — minimum 3 characters required.',
    [ErrorLogsTestIds.errorLogsList]:
      'Browse captured backend exceptions and frontend errors — use the time filter and tabs to narrow the view.',
    [ErrorLogsTestIds.tabs]:
      'Two views of the same error stream: All Records shows every occurrence; Patterns groups recurring errors by message and exception type.',
    [ErrorLogsTestIds.tabAllRecords]:
      'Every error event as a separate row, sorted by timestamp.',
    [ErrorLogsTestIds.tabPatterns]:
      'Recurring errors grouped by message and exception type — sort by count to find the most frequent failures.',
    [ErrorLogsTestIds.allRecordsCount]: null,
    [ErrorLogsTestIds.patternsCount]: null,
    [ErrorLogsTestIds.allRecordsTable]:
      'One row per recorded error. Click to inspect the full stack trace, request context, and related session.',
    [ErrorLogsTestIds.patternsTable]:
      'One row per error pattern (same exception type and message). Shows frequency and last-seen timestamp.',
    [ErrorLogsTestIds.statCards]:
      'Per-module summary tiles showing how many errors occurred in the selected time window.',
    [ErrorLogsTestIds.statCardTotal]:
      'Total error events recorded in the selected time window across all modules.',
    [ErrorLogsTestIds.statCardOthers]:
      'Errors not attributed to a monitored module — usually infrastructure or unknown origin.',
    [ErrorLogsTestIds.statsLoading]:
      'Error counts per module are loading.',
    [ErrorLogsTestIds.filterPeriod]:
      'Narrow displayed errors to a time window — last hour, last day, last week, or a custom range.',
    [ErrorLogsTestIds.allMinQHint]:
      'Free-text search needs at least 3 characters before querying the database.',
    [ErrorLogsTestIds.patternsMinQHint]:
      'Free-text search needs at least 3 characters before querying the database.',
    [ErrorLogsTestIds.emptyStateCard]:
      'No errors match the current filters — either the system is healthy in this window or the filters are too narrow.',
    [ErrorLogsTestIds.colAllTime]: null,
    [ErrorLogsTestIds.colAllType]:
      'Severity or type of the error event — exception, warning, or frontend report.',
    [ErrorLogsTestIds.colAllException]:
      'Fully qualified Java exception class or frontend error name.',
    [ErrorLogsTestIds.colAllMessage]:
      'The error message — search matches this column only.',
    [ErrorLogsTestIds.colAllModule]:
      'Source module that raised the error — backend module name or "frontend" for browser-side errors.',
    [ErrorLogsTestIds.colAllSourceType]:
      'Whether the error was raised on the backend, the frontend, or in the browser console.',
    [ErrorLogsTestIds.colAllSessionId]:
      'Session identifier — open the request inspector to see the full request waterfall.',
    [ErrorLogsTestIds.colPatternCount]:
      'Number of times this pattern fired in the current window.',
    [ErrorLogsTestIds.colPatternException]:
      'Fully qualified exception class for this pattern.',
    [ErrorLogsTestIds.colPatternMessage]:
      'Representative message for this pattern — variable parts (IDs, timestamps) are normalised.',
    [ErrorLogsTestIds.colPatternModule]:
      'Module from which this pattern originated.',
    [ErrorLogsTestIds.colPatternLastSeen]:
      'When this pattern most recently fired.',
    [ErrorLogsTestIds.btnRefresh]: null,
    [ErrorLogsTestIds.btnClearAll]:
      'Permanently delete every error log entry — open confirmation dialog first.',
    [ErrorLogsTestIds.btnConfirmClearAll]:
      'Confirm deletion of every error log entry — this cannot be undone.',
    [ErrorLogsTestIds.btnCancelClearAll]: null,
  },
}
